var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.165 5.9934L10.1634 5.6393C10.1513 4.2348 10.0666 2.98174 9.9206 2.18763C9.9206 2.17331 9.7613 1.38572 9.6599 1.12355C9.5006 0.74463 9.2126 0.42299 8.8515 0.2192C8.5624 0.0738001 8.2592 0 7.9417 0C7.6922 0.01157 7.2806 0.13714 6.98692 0.24242L6.74283 0.33596C5.12612 0.97815 2.03561 3.07656 0.85199 4.3598L0.76473 4.4495L0.37527 4.8698C0.12982 5.1915 0 5.5847 0 6.0077C0 6.3866 0.11563 6.7656 0.3469 7.0718C0.41614 7.171 0.52766 7.2983 0.62693 7.4058L1.006 7.8026C2.31046 9.1243 5.13485 10.9782 6.59883 11.5924C6.59883 11.6057 7.5086 11.9857 7.9417 12H7.9995C8.6639 12 9.2846 11.6211 9.6021 11.0086C9.6888 10.8412 9.772 10.5132 9.8352 10.2252L9.949 9.6813C10.0788 8.8067 10.165 7.465 10.165 5.9934ZM16.4967 7.5183C17.3269 7.5183 18 6.8387 18 6.0004C18 5.1622 17.3269 4.4825 16.4967 4.4825L12.7975 4.8097C12.1463 4.8097 11.6183 5.3417 11.6183 6.0004C11.6183 6.6581 12.1463 7.1912 12.7975 7.1912L16.4967 7.5183Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteArrowLeft);
export default __webpack_public_path__ + "static/media/white-arrow-left.30313f9e306bf5d72fc32fe7507403ce.svg";
export { ForwardRef as ReactComponent };